import { render, staticRenderFns } from "./ColorPage.vue?vue&type=template&id=8eeefd56&scoped=true&"
import script from "./ColorPage.vue?vue&type=script&lang=js&"
export * from "./ColorPage.vue?vue&type=script&lang=js&"
import style0 from "./ColorPage.vue?vue&type=style&index=0&id=8eeefd56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eeefd56",
  null
  
)

export default component.exports